import { BUSCAR_MAPA_VIAGEM } from '../../actions/types'

const initialState = null

export default function reducerMapaViagem (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_MAPA_VIAGEM: {
      return action.payload.data;
    }


    default: {
      return state
    }
  }
}
